export default __webpack_public_path__ + "static/media/items-expected.aa97a854.svg";